import { Pipe, PipeTransform } from "@angular/core";
import { catchError, Observable, of, shareReplay } from "rxjs";
import { KpiService } from "../services/kpi.service";
import { KpiType } from "../helpers/enum";

@Pipe({
    name: 'kpiLastDate',
    pure: false
  })
  export class KpiLastDatePipe implements PipeTransform {
    private cache = new Map<string, Observable<Date>>();
  
    constructor(private service: KpiService) {}
  
    transform(idKpi: number, kpiType: KpiType): Observable<Date> | null {
      if (!idKpi || !kpiType) return null;
        
      const key = `${idKpi}-${kpiType}`;
      if (!this.cache.has(key)) {
        switch(kpiType){
          case KpiType.KpiData:
            const reqKpiData$ = this.service.getKpiDataLastDate(idKpi).pipe(
              shareReplay({ bufferSize: 1, refCount: true }),
              catchError(() => of(new Date(NaN)))
            );
            this.cache.set(key, reqKpiData$);
            break;
          case KpiType.KpiActividadTallerVisits:
            const reqKpiActividadTallerVisits$ = this.service.getKpiActividadTallerVisitsLastDate().pipe(
              shareReplay({ bufferSize: 1, refCount: true }),
              catchError(() => of(new Date(NaN)))
            );
            this.cache.set(key, reqKpiActividadTallerVisits$);
            break;
          case KpiType.KpiActividadTallerBillingHour:
            const reqKpiActividadTallerBillingHour$ = this.service.getKpiActividadTallerBillingHourLastDate().pipe(
              shareReplay({ bufferSize: 1, refCount: true }),
              catchError(() => of(new Date(NaN)))
            );
            this.cache.set(key, reqKpiActividadTallerBillingHour$);
            break;
          case KpiType.KpiActividadTallerTfa:
            const reqKpiActividadTallerTfa$ = this.service.getKpiActividadTallerTfaLastDate().pipe(
              shareReplay({ bufferSize: 1, refCount: true }),
              catchError(() => of(new Date(NaN)))
            );
            this.cache.set(key, reqKpiActividadTallerTfa$);
            break;
          case KpiType.KpiExperienciaClienteBonusCalidad:
            const reqKpiExperienciaClienteBonusCalidad$ = this.service.getKpiExperienciaClienteBonusCalidadLastDate().pipe(
              shareReplay({ bufferSize: 1, refCount: true }),
              catchError(() => of(new Date(NaN)))
            );
            this.cache.set(key, reqKpiExperienciaClienteBonusCalidad$);
            break;
        }        
      }
      return this.cache.get(key)!;
    }
  }